import { MfaApiModel } from '../../../api/users/models/mfa.api.model';

export enum MfaTypesEnum {
    email = 'EMAIL',
    mobileApp = 'MOBILE_APP'
}

export interface MfaVerifyModel {
    methodId: number;
    verificationCode?: string;
    name?: string;
    username?: string;
    email?: string;
    preferred?: boolean;
};

export enum MfaStatusTypes {
    MFA_SETUP_REQUIRED = 'MFA_SETUP_REQUIRED',
    MFA_VALIDATION_REQUIRED = 'MFA_VALIDATION_REQUIRED',
    MFA_VALIDATION_FAILED = 'MFA_VALIDATION_FAILED'
}
export class MfaStatusModel {
    status: MfaStatusTypes;
    allowedMfaMethods: MfaApiModel[];
    verifiedMfaMethods: MfaApiModel[];

    constructor(statusModel: MfaStatusModel) {
        this.allowedMfaMethods = statusModel.allowedMfaMethods;
        this.verifiedMfaMethods = statusModel.verifiedMfaMethods;
        this.status = statusModel.status;
    }
}

export class MfaModel {
    id: number;
    type: MfaTypesEnum;
    email?: string;
    name?: string;
    seed?: string;
    preferred?: boolean;
    confirmationCode?: string;

    constructor(apiModel: MfaApiModel) {
        this.id =  apiModel.id;
        this.type = apiModel.type;
        this.email = apiModel.email;
        this.name = apiModel.name;
        this.preferred = apiModel.preferred;
        this.seed = apiModel.seed;
        this.confirmationCode = null;
    }
    toApiModel(): MfaApiModel {
        return {
            id:  this.id,
            type: this.type,
            email: this.email ? this.email : null,
            name: this.name ? this.name : null,
            preferred: this.preferred,
        };
    }

    toMfaVerifyModel(username?: string): MfaVerifyModel {
        return {
            methodId:  this.id,
            name: this.name,
            email: this.email,
            username: username,
            verificationCode: this.confirmationCode,
            preferred: this.preferred
        };
    }
};
